<template>
  <div id="h-app">
    <m-layout v-if="showSubApp" />
    <!-- 如果没有登录信息 需要 进入router-view 登录页 -->
    <router-view v-else></router-view>
  </div>
</template>

<script>
  import MC from '@/module/MC'
  import mLayout from '@/module/layout'
  import { mapState, mapMutations } from 'vuex'

  export default {
    components: { mLayout },
    methods: {
      ...mapMutations('common', ['setIsErp'])
    },
    computed: {
      ...mapState('common', ['showSubApp'])
    },
    created () {
      MC.init()

      const isErp = MC.getCookie('isErp')

      if (isErp) {
        this.setIsErp(isErp)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/conf/home/App.vue